import brands from "@/api/brands";

export default {
  state: {
    brands:[],
  },
  mutations: {
    ["RETRIEVE_BRANDS"](state, data) {
      state.brands = data;
    },
  },
  actions: {
    async retrieveBrands(context) {
      try {
        let params = {
          management_id: await context.dispatch("showManagementID")
        };
        let res = await brands.show(params);
        context.commit("RETRIEVE_BRANDS", res.data.data);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async showBrands(context, brand_id) {
      try {
        let params = {
          management_id: await context.dispatch("showManagementID")
        };
        params.brand_id = brand_id;

        let res = await brands.show(params);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async insertBrand(context, params) {
      try {
        params.management_id = await context.dispatch("showManagementID");
        await brands.insert(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateBrand(context, params) {
      try {
        params.management_id = await context.dispatch("showManagementID");
        await brands.update(params);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteBrand(context, brand_id) {
      try {
        let params = {
          management_id: await context.dispatch("showManagementID")
        };
        params.brand_id = brand_id;
        await brands.del(params);
      } catch (error) {
        console.log(error);
      }
    },
    async initializeBrands(context) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID")
        };
        await brands.init(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrderBrands(context, params) {
      try {
        await brands.updateOrder(params);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    getBrands(state) {
      return state.brands;
    }
  }
};
